import { Edit } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import {
  Box,
  Chip,
  DialogActions,
  DialogContent,
  TextField,
} from '@mui/material';
import { ModalLink, Modal } from '@scorenco/components';
import { useTranslation, useUpdateTournamentPhase } from '@scorenco/core';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import { T_KEYS } from '../../../../../../../translations';

export const PhaseName = ({ phase, ...rest }) => {
  return (
    <ModalLink Modal={PhaseNameModal} modalProps={{ phase }}>
      <Chip
        label={
          <Box display="flex" alignItems="center">
            {phase.name}
            <Edit sx={{ fontSize: '1rem !important', ml: 1 }} />
          </Box>
        }
        color="primary"
        sx={{ mb: 2, '.MuiChip-icon': { fontSize: '1rem !important' } }}
        size="small"
        clickable
        // icon={<Edit sx={{ fontSize: '1rem !important' }} />}
        {...rest}
      />
    </ModalLink>
  );
};

const PhaseNameModal = ({ phase, closeModal }) => {
  const phaseMutation = useUpdateTournamentPhase();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const formikName = useFormik({
    initialValues: {
      id: phase.id,
      name: phase.name,
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        await phaseMutation.execute({
          id: phase.id,
          _set: {
            name: values.name,
          },
        });
        closeModal();
        enqueueSnackbar(t(T_KEYS.SUCCESS_EDIT), {
          variant: 'success',
        });
      } catch (error) {
        console.error('error: ', error);
        enqueueSnackbar(t(T_KEYS.ERROR_MESSAGE), {
          variant: 'error',
        });
      }
    },
  });

  return (
    <Modal title="Changer le nom du groupe" closeModal={closeModal}>
      <Box component="form" onSubmit={formikName.handleSubmit}>
        <DialogContent
          style={{
            paddingTop: '1rem',
          }}
        >
          <TextField
            id="name"
            name="name"
            value={formikName.values.name}
            onChange={formikName.handleChange}
          />
        </DialogContent>
        <DialogActions sx={{ m: 0, p: 1, justifyContent: 'center' }}>
          <LoadingButton
            type="submit"
            variant="contained"
            color="secondary"
            loading={phaseMutation.status.loading}
          >
            {t(T_KEYS.EDIT)}
          </LoadingButton>
        </DialogActions>
      </Box>
    </Modal>
  );
};
